import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';

export const LocationCardWrapper = styled('div', {
  background: '$core.color.neutral.0',
  cursor: 'pointer',
  width: '408px',
  textAlign: 'left',
  '@media (max-width: 464px)': {
    height: 'auto',
  },
  '&.location-card-map-view': {
    width: '320px',
    height: '162px',
    '@media (max-width: 464px)': {
      height: 'auto',
    },
    '.location-details': {
      '>div': {
        width: 'auto',
        height: 'inherit',
      },
    },
  },
});

export const PreferredBadgeWrapper = styled('div', {
  paddingBottom: '8px',
  '@media (max-width: 464px)': {
    paddingBottom: '4px',
  },
});

export const LocationCardGroup = styled(Layout.Group, {
  '&.abyss-layout-group': {
    alignItems: 'flex-start',
    '@media (max-width: 464px)': {
      // height: '125px',
    },
  },
});

export const LocationDetailsStack = styled(Flex, {
  flex: 1,
  gap: '8px',
  lineHeight: '23px',
  '@media (max-width: 464px)': {
    lineHeight: '18px',
  },
  '>span': {
    overflowWrap: 'anywhere',
    width: '100%',
  },
});

export const LocationDetailsAddress = styled(Text, {
  lineHeight: '24px',
  fontSize: '18px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '342px',
  '@media (max-width: 464px)': {
    lineHeight: '20px',
    fontSize: '14.22px',
    maxWidth: '258px',
  },
});

export const LocationBadgeRow = styled(Flex, {
  height: '20px',
  gap: '16px',
  flexDirection: 'column',
});

export const MilesButton = styled('button', {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
});

export const AcceptingNewPatientsBadge = styled('div', {
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  fontSize: '12px',
});

export const StyledCheckIcon = styled('div', {
  height: '24px',
});

export const UpdateButtonMobileViewContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
});

export const UpdateButtonMobileView = styled(Button, {
  '&.abyss-button-root': {
    display: 'flex',
    padding: '8px 20px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    height: '42px',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '20px',
    '.abyss-insert-element-after': {
      paddingLeft: 0,
    },
  },
});
